import type { TOC } from '@ember/component/template-only'
import { on } from '@ember/modifier'
import { t } from 'ember-intl'
import LayoutBlocksModal from 'teacher-ui-client/components/layout-blocks/modal'
import { UiButton } from 'teacher-ui-client/components/ui-button'
import { ButtonAppearance } from 'teacher-ui-client/components/ui-button/themes'
import type BookLibraryCollection from 'teacher-ui-client/models/book-library/collection'

interface Signature {
  Args: {
    showModal: boolean
    onDeleteCollectionCancel: () => void
    deleteCandidate: BookLibraryCollection
    onDeleteCollectionSubmit: () => void
  }
}

export const BookLibraryDeleteCollectionModal: TOC<Signature> = <template>
  <LayoutBlocksModal
    @title={{t "bookLibrary.collection.delete.modal.title"}}
    @showModal={{@showModal}}
    @close={{@onDeleteCollectionCancel}}
  >
    <div class="p-10">
      <p class="mb-3">
        {{t "bookLibrary.collection.delete.modal.instructions"}}
        <span class="font-bold">{{@deleteCandidate.name}}</span>
      </p>
      <p class="font-bold">
        {{t "bookLibrary.collection.delete.modal.areYouSure"}}
      </p>
    </div>
    <div class="border-dusty-black-100 border-t px-4 pt-4 pb-2 text-right">
      <UiButton class="mr-2" @appearance={{ButtonAppearance.regular}} {{on "click" @onDeleteCollectionCancel}}>
        {{t "bookLibrary.collection.delete.modal.cancel"}}
      </UiButton>
      <UiButton {{on "click" @onDeleteCollectionSubmit}}>
        {{t "bookLibrary.collection.delete.modal.confirm"}}
      </UiButton>
    </div>
  </LayoutBlocksModal>
</template>

export default BookLibraryDeleteCollectionModal
